import { CurrencyValues } from '@config/values/currency.values';

/**
 * CHF cash uses 5 Rp. steps; round tip amount in centimes so UI and API match.
 */
export function roundTipAmountCents(amountCents: number, currencyCode: string | undefined): number {
  const code = (currencyCode ?? '').toUpperCase();
  if (code === CurrencyValues.CHF || code === 'CHF') {
    return Math.round(amountCents / 5) * 5;
  }
  return Math.round(amountCents);
}

/** Tip in major currency units from cart total (same units) and percent. */
export function tipAmountFromPercent(
  totalAmountCurrencyUnits: number,
  percent: number,
  currencyCode: string | undefined,
): number {
  const rawCents = Math.round(totalAmountCurrencyUnits * 100 * (percent / 100));
  const cents = roundTipAmountCents(rawCents, currencyCode);
  return cents / 100;
}
